import React, { useEffect } from 'react';
import styled from 'styled-components';
import { StyledIcon, SvgSrc } from '~/components/shared/Icon/Icon';
import Image from '~/components/shared/Image/Image';
import { useDispatch, useSelector } from 'react-redux';
import { getSignicatStatus } from '~/store/actions/invoiceActions';
import useTranslate from '~/hooks/useTranslate';
import { RootState } from '~/store/types/sharedTypes';
import PaymentMethodsHeader from './PaymentMethodsHeader';
import { PaymentMethodMainContainer } from '../../Invoice';

const PaymentMethodBodyContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  align-self: center;
  padding: 0 2em;
  flex: 1 0;
  width: 100%;
  background-color: #f8f9f5;
  @media (orientation: landscape) {
    max-width: 40em;
  }
`;

const SpinnerIcon = styled(StyledIcon)`
  height: 60px;
  width: 60px;
  margin-top: 100px;
  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;

const BankIDContainer = styled(PaymentMethodBodyContainer)`
  margin: 20px;
  background-color: white;
`;

const Loader = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: 100%;
  max-height: 100%;
`;

const BankIdText = styled.div`
  display: flex;
  justify-content: center;
  max-width: 300px;
  text-align: center;
  color: #757575;
  margin-top: 45px;
  font-size: 20px;
`;

const ImageContainer = styled.div`
  margin: 0 auto;
  width: 7em;
`;

interface Props {
  personalNumber: string;
}

const BankID: React.FC<Props> = (props) => {
  const { personalNumber } = props;
  const dispatch = useDispatch();
  const translate = useTranslate();
  const { externalId, id } = useSelector(
    (state: RootState) => state.factoring.singleInvoice
  );

  useEffect(() => {
    const interval = setInterval(() => {
      dispatch(getSignicatStatus(externalId ?? id, personalNumber));
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <PaymentMethodMainContainer>
      <PaymentMethodsHeader
        text={translate('Back').toString()}
        hideCancelButton
      />
      <BankIDContainer>
        <Loader>
          <SpinnerIcon
            style={{ animation: 'spin infinite 3s linear' }}
            color="#444444"
            icon={SvgSrc.Spinner}
          />
        </Loader>
        <ImageContainer style={{ marginTop: '60px' }}>
          <Image src="bank_id.png" />
        </ImageContainer>
        <BankIdText>
          {translate('Invoices.OpenBankIdApp').toString()}
        </BankIdText>
      </BankIDContainer>
    </PaymentMethodMainContainer>
  );
};

export default BankID;
